import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Zoom,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} timeout={350} />;
});

export default function CustomAddModal(props) {
  const {
    handleClose,
    title,
    onSubmitConfirm,
    open,
    saveLabel = 'Add',
    maxWidth = 'sm',
    disableOutClick = false,
    disableSave = false,
    hideCloseButton = false,
  } = props;

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={maxWidth}
      TransitionComponent={Transition}
      onClose={disableOutClick ? () => {} : handleClose}
      aria-labelledby="custom-add-dialog-title"
    >
      <DialogTitle id="custom-add-dialog-title" sx={{ p: 0, m: 0 }}>
        <Box
          sx={{
            p: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              color: 'rgba(255, 255, 255, 0.5)',
              '&:hover': {
                color: '#fff',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>{props.children}</DialogContent>
      <DialogActions sx={{ p: 2, gap: 1, borderTop: '1px solid', borderColor: 'divider' }}>
        {!hideCloseButton && (
          <Button onClick={handleClose} variant="outlined" color="secondary" autoFocus>
            Close
          </Button>
        )}
        {!disableSave && (
          <Button onClick={onSubmitConfirm} variant="contained" color="primary">
            {saveLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
